import PropTypes from 'prop-types';
import React from 'react';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';
import { Link } from 'react-router-dom';

export const DropdownNavItem = ({ label, to, onClick }) => (
  <DropdownItem tag={Link} to={to} onClick={onClick}>
    {label}
  </DropdownItem>
);

export class NavDropdown extends React.Component {
  static propTypes = {
    children: PropTypes.arrayOf(PropTypes.node).isRequired,
  };

  state = {
    dropdownOpen: false,
  };

  toggle = () =>
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));

  render() {
    return (
      <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
        <div className="d-block d-lg-none d-xl-none">
          <DropdownToggle color="primary" caret className="mb-1 nav-item w-100">
            {this.props.label}
          </DropdownToggle>
          <DropdownMenu>{this.props.children}</DropdownMenu>
        </div>
        <div className="d-none d-lg-block d-xl-block">
          <DropdownToggle nav caret className="nav-item p-1">
            {this.props.label}
          </DropdownToggle>
          <DropdownMenu>{this.props.children}</DropdownMenu>
        </div>
      </Dropdown>
    );
  }
}
